/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { useId } from "react";
import { Button } from "ui/Button";

import type { FC } from "react";

type Props = {
  isPhoneNumberVerified: boolean;
  isQuantitySelected: boolean;
  onConfirmEntry: () => void;
};

export const ResaleApplicationAction: FC<Props> = ({
  isPhoneNumberVerified,
  isQuantitySelected,
  onConfirmEntry,
}) => {
  const { t } = useI18n();
  const descriptionId = useId();
  const isDisabled = !isPhoneNumberVerified || !isQuantitySelected;
  const hasError = !isPhoneNumberVerified;
  const classes = styles({ hasError });

  return (
    <div css={classes.root}>
      <Button
        type="button"
        size="full"
        disabled={isDisabled}
        aria-describedby={descriptionId}
        onClick={onConfirmEntry}
      >
        {t("event.resale.entry.next")}
      </Button>
      <p id={descriptionId} css={classes.description}>
        {isPhoneNumberVerified
          ? t("event.resale.entry.confirmEntryDescription")
          : t("event.resale.entry.phoneVerificationRequiredForEntry")}
      </p>
    </div>
  );
};

type StyleProps = {
  hasError: boolean;
};

const styles = ({ hasError }: StyleProps) => ({
  root: css`
    display: grid;
    gap: 10px;
  `,
  description: css`
    margin: 0;
    color: ${hasError ? "#f00" : "#777"};
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
  `,
});
